import { render, staticRenderFns } from "./OtherIdentifiersSelector.vue?vue&type=template&id=1e68c28e&"
import script from "./OtherIdentifiersSelector.vue?vue&type=script&lang=js&"
export * from "./OtherIdentifiersSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports